// Datos por Comunidad Autónoma (codauto INE como clave).
// Fuentes: Banco de España (deuda PDE, 1T 2026) · Ministerio de Sanidad (SISLE-SNS, 31/12/2025) · INE (población).
export const CCAA = {
  "01": { name: "Andalucía", deudaTotal: 42092, deudaHab: 4949, pacientes: 199950, por1000: 23.51, esperaMedia: 173, mas6meses: 64302 },
  "02": { name: "Aragón", deudaTotal: 9424, deudaHab: 6839, pacientes: 25783, por1000: 18.71, esperaMedia: 132 },
  "03": { name: "Asturias", deudaTotal: 3861, deudaHab: 3812, pacientes: 22402, por1000: 22.12, esperaMedia: 91 },
  "04": { name: "Illes Balears", deudaTotal: 8398, deudaHab: 6699, pacientes: 17075, por1000: 13.62, esperaMedia: 105 },
  "05": { name: "Canarias", deudaTotal: 6559, deudaHab: 2978, pacientes: 32131, por1000: 14.59, esperaMedia: 106 },
  "06": { name: "Cantabria", deudaTotal: 3216, deudaHab: 5531, pacientes: 14490, por1000: 24.92, esperaMedia: 137 },
  "07": { name: "Castilla y León", deudaTotal: 14237, deudaHab: 6071, pacientes: 24786, por1000: 10.57, esperaMedia: 87 },
  "08": { name: "Castilla-La Mancha", deudaTotal: 16478, deudaHab: 8207, pacientes: 36260, por1000: 18.06, esperaMedia: 92 },
  "09": { name: "Cataluña", deudaTotal: 90336, deudaHab: 11346, pacientes: 197768, por1000: 24.84, esperaMedia: 142, mas6meses: 63228 },
  "10": { name: "Comunitat Valenciana", deudaTotal: 64348, deudaHab: 12358, pacientes: 51600, por1000: 9.91, esperaMedia: 88, mas6meses: 8309 },
  "11": { name: "Extremadura", deudaTotal: 5409, deudaHab: 5302, pacientes: 22404, por1000: 21.96, esperaMedia: 135 },
  "12": { name: "Galicia", deudaTotal: 12282, deudaHab: 4665, pacientes: 49554, por1000: 18.82, esperaMedia: 73, mas6meses: 2810 },
  "13": { name: "Comunidad de Madrid", deudaTotal: 40574, deudaHab: 5658, pacientes: 80525, por1000: 11.23, esperaMedia: 50, mas6meses: 657 },
  "14": { name: "Región de Murcia", deudaTotal: 14168, deudaHab: 8916, pacientes: 34197, por1000: 21.52, esperaMedia: 103 },
  "15": { name: "Comunidad Foral de Navarra", deudaTotal: 2451, deudaHab: 3629, pacientes: 10861, por1000: 16.08, esperaMedia: 96 },
  "16": { name: "País Vasco", deudaTotal: 11197, deudaHab: 5029, pacientes: 24069, por1000: 10.81, esperaMedia: 64 },
  "17": { name: "La Rioja", deudaTotal: 1880, deudaHab: 5720, pacientes: 7822, por1000: 23.80, esperaMedia: 78 },
};

export const INDICADORES = {
  deudaTotal: {
    key: "deudaTotal",
    label: "Deuda total",
    dot: "#AA151B",
    unit: "M€",
    desc: "Importe de deuda de la Comunidad Autónoma según el Protocolo de Déficit Excesivo (PDE).",
    ramp: ["#fbe3e1", "#f0a49c", "#dd5f52", "#b81f21", "#7a0f12"],
    fmt: (v) => `${v.toLocaleString("es-ES")} M€`,
  },
  deudaHab: {
    key: "deudaHab",
    label: "Deuda por habitante",
    dot: "#1D4ED8",
    unit: "€/hab.",
    desc: "Deuda autonómica dividida entre la población. Permite comparar comunidades de distinto tamaño.",
    ramp: ["#e2ebfb", "#a9c2f2", "#6a93e6", "#2f63cf", "#173a86"],
    fmt: (v) => `≈ ${v.toLocaleString("es-ES")} €`,
  },
  pacientes: {
    key: "pacientes",
    label: "Lista de espera",
    dot: "#15803D",
    unit: "pacientes",
    desc: "Pacientes pendientes de una intervención quirúrgica en la lista de espera estructural del SNS.",
    ramp: ["#dff2e5", "#a5d9b8", "#5cb37e", "#2b8a4e", "#155f30"],
    fmt: (v) => `${v.toLocaleString("es-ES")} pacientes`,
  },
};
